// A control is at least 44px tall on a touch screen (WCAG 2.5.8 target size). With a mouse it
// keeps its own size: desktop layouts do not grow.
export const TOUCH_TARGET_MIN_SIZE_PX = 44;

// A medium MUI Button with a mouse: a 24.5px line and 6px of padding above and below.
const MUI_BUTTON_HEIGHT_PX = 36.5;

// On a touch screen the button is 44px tall and gives the extra back below it, so nothing around
// it moves: its tap area reaches 7.5px further down, into the space under the button.
export const touchTargetHeightSx = {
  '@media (pointer: coarse)': {
    minHeight: `${TOUCH_TARGET_MIN_SIZE_PX}px`,
    marginBottom: `${MUI_BUTTON_HEIGHT_PX - TOUCH_TARGET_MIN_SIZE_PX}px`,
  },
} as const;
